<template>
	<div class="notice_popup human int">
		<div class="close" @click="$emit('close', false)">
			<img src="/images/close.png" alt="닫기"/>
		</div>
		<div class="tit" style="font-size: 24px;" v-if="admApprYn == 'N'">관리자 등급 심사 후 가능합니다.</div>
		<div class="tit" style="font-size: 24px; line-height: 30px;" v-else>이력서 등록 후<br />평가가 가능합니다.</div>
		<div class="select-btn">
			<div class="btn" style="background-color: #0165FF;" @click="$emit('close', false)">확인</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['param'],
	data() { 
		return {
			admApprYn: this.param.admApprYn
		} 
	},
	methods : {}
}
</script>